import CloseIcon from '@mui/icons-material/CloseOutlined';
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import { JobDetail } from "../../routes/doa-forecast-stats/DoaForecastStatsData";
import { closeButtonStyle, headerCellStyle } from "./styled";

export interface IJobsRequiredTableProps {
  jobDetails: JobDetail[],
  isDoaAdmin: boolean,
  redBorderClassName: string,
  onClose: () => void,
}

export const JobsRequiredTable: React.FC<IJobsRequiredTableProps> = ({
  jobDetails,
  isDoaAdmin,
  redBorderClassName,
  onClose,
}) => (
  <>
    <TableRow className={`${redBorderClassName} subTableHeadRow`}>
      <TableCell sx={{ position: 'relative' }} colSpan={isDoaAdmin ? 9 : 7}>
        <Box sx={{ ...headerCellStyle, justifyContent: 'space-between' }}>
          Job/Site Details
          <Box sx={closeButtonStyle} onClick={onClose}><CloseIcon /></Box>
        </Box>
      </TableCell>
    </TableRow>
    {!jobDetails?.length && <TableRow>
      <TableCell colSpan={4} className='noData'>
        No data
      </TableCell>
    </TableRow>}
    {
      jobDetails.map(d => (
        <TableRow className={`${redBorderClassName} subTableRow`} key={d.jobDetail}>
          {Object.values(d).map((dv, i) => {
            const hasExpandRow = (i === 1) || (i === 2 && isDoaAdmin) || (i === 5 && isDoaAdmin);
            return (
              <React.Fragment key={i}>
                <TableCell className={hasExpandRow ? 'alignRight' : ''}>
                  {dv}
                </TableCell>
                {hasExpandRow && <TableCell />}
              </React.Fragment>
            )
          })}
        </TableRow>
      ))
    }
  </>
)   